import { classNames, LONG_TEXT_WRAP_CLASSES } from "../../utils";

interface Props {
  text: string;
}

const Summary360CompanyBanner = ({ text }: Props) => {
  const trimmed = text.trim();
  if (!trimmed) {
    return null;
  }

  return (
    <div
      className={classNames(
        "border border-secondaryDarkBlue bg-aliceBlue rounded-lg text-sm text-secondaryDarkBlue p-3 mb-4",
        LONG_TEXT_WRAP_CLASSES
      )}
    >
      {trimmed}
    </div>
  );
};

export default Summary360CompanyBanner;
